var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReturnArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333313,
    width: 32,
    height: 32,
    rx: 4.8,
    fill: "#F1F8FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0521 13.9375L18.5521 9.1875C18.0833 8.78125 17.3333 9.125 17.3333 9.78125V12.2812C12.3021 12.3125 8.33331 13.3438 8.33331 18.0938C8.33331 20 9.55206 21.9062 10.9271 22.9062C11.3333 23.2188 11.9583 22.8125 11.8021 22.3125C10.3958 17.7812 12.4583 16.5938 17.3333 16.5312V19.25C17.3333 19.9062 18.0833 20.25 18.5521 19.8438L24.0521 15.0938C24.3958 14.7812 24.3958 14.25 24.0521 13.9375Z",
    fill: "#0A3751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnArrow);
export default __webpack_public_path__ + "static/media/return-arrow.e7a7a85f0564c7320e8502dc7ab3212f.svg";
export { ForwardRef as ReactComponent };